import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { ClaimantService } from '../../services/claimant/claimant.service';
import { Claimant } from '../../models/claimant';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { FileSizePipe } from '../../shared/file-size.pipe';
import { Authenticate } from '../../models/authenticate';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-audit-request',
  templateUrl: './audit-request.html',
  styleUrls: ['./audit-request.css'],
  imports: [ReactiveFormsModule, CurrencyPipe, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule],

  providers: [
    FileSizePipe
  ]
})
export class AuditRequest implements OnInit {
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;


  submitted = false;
  clicked = false;
  clickedOnce = false;
  changed = false;
  allStates: any = [];
  allCountries: any = [];
  claimantsInformation: FormGroup;
  submittedClaim: Claimant;
  au: Authenticate;
  response: string | undefined;
  dateLoaded: Date;
  claimStartTime: string;
  claimEndTime: string;
  cdList: any = [];
  showDivProvince: boolean = false;
  showDivCityStateZip: boolean = true;
  showDivPurchaseUploadDocs: boolean = false;
  showDivDisagreePurchaseMessage: boolean = false;
  selectedCountry: any;
  showSubmittalErrorWarning: boolean = false;

  // Tracks which purchase-table cell (control name) is currently being edited inline.
  editingCell: string | null = null;

  // Snapshot of the original purchase-matrix control values (as loaded from the authenticated user),
  // used to determine which fields were actually updated by the claimant before submitting.
  purchaseMatrixBaseline: { [controlName: string]: any } = {};

  // All editable purchase-information controls, grouped by defendant, matching the table rows.
  purchaseMatrix = [
    { label: 'Butterball', controls: ['butterball2010', 'butterball2011', 'butterball2012', 'butterball2013', 'butterball2014', 'butterball2015', 'butterball2016'] },
    { label: 'Cargill', controls: ['cargill2010', 'cargill2011', 'cargill2012', 'cargill2013', 'cargill2014', 'cargill2015', 'cargill2016'] },
    { label: 'Cooper Farms', controls: ['cooperFarms2010', 'cooperFarms2011', 'cooperFarms2012', 'cooperFarms2013', 'cooperFarms2014', 'cooperFarms2015', 'cooperFarms2016'] },
    { label: 'Farbest Foods', controls: ['farbestFoods2010', 'farbestFoods2011', 'farbestFoods2012', 'farbestFoods2013', 'farbestFoods2014', 'farbestFoods2015', 'farbestFoods2016'] },
    { label: 'Foster Farms', controls: ['fosterFarms2010', 'fosterFarms2011', 'fosterFarms2012', 'fosterFarms2013', 'fosterFarms2014', 'fosterFarms2015', 'fosterFarms2016'] },
    { label: 'Hormel', controls: ['hormel2010', 'hormel2011', 'hormel2012', 'hormel2013', 'hormel2014', 'hormel2015', 'hormel2016'] },
    { label: 'Perdue', controls: ['perdue2010', 'perdue2011', 'perdue2012', 'perdue2013', 'perdue2014', 'perdue2015', 'perdue2016'] },
    { label: 'Prestage', controls: ['prestage2010', 'prestage2011', 'prestage2012', 'prestage2013', 'prestage2014', 'prestage2015', 'prestage2016'] },
    { label: 'Tyson', controls: ['tyson2010', 'tyson2011', 'tyson2012', 'tyson2013', 'tyson2014', 'tyson2015', 'tyson2016'] },
  ];

  supportingDocuments: any = [];

  validation_ClaimDetailsErrorMessage = {
    purchaseYear: [
      { type: 'required', message: 'This Field is required' },
    ],
    defendant: [
      { type: 'required', message: 'This Field is required' },
    ],
    purchaseAmount: [
      { type: 'required', message: 'This field is required' },
      { type: "maxlength", message: "Field cannot be more than 15 digits" },
      { type: "pattern", message: "Only use numbers with optional period (.) and up to 4 digits past decimal." }
    ],
  };
  constructor(
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private claimantService: ClaimantService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.dateLoaded = new Date();
    this.dateLoaded = new Date();
    this.claimStartTime = this.dateLoaded.toLocaleTimeString();
    this.loadAllStates();
    this.loadAllCountries();
    this.selectedCountry = "United States";
    this.au = this.storage.retrieve('authenticatedUser');
    this.claimantsInformation = this.fb.group({
      pin: [this.au.pin],
      uniqueId: [this.au.uniqueId],
      purchaseNetTotal: [this.au.purchaseNetTotal],
      butterball2010: [this.au.butterball2010, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      butterball2011: [this.au.butterball2011, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      butterball2012: [this.au.butterball2012, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      butterball2013: [this.au.butterball2013, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      butterball2014: [this.au.butterball2014, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      butterball2015: [this.au.butterball2015, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      butterball2016: [this.au.butterball2016, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],

      cargill2010: [this.au.cargill2010, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      cargill2011: [this.au.cargill2011, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      cargill2012: [this.au.cargill2012, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      cargill2013: [this.au.cargill2013, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      cargill2014: [this.au.cargill2014, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      cargill2015: [this.au.cargill2015, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      cargill2016: [this.au.cargill2016, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],

      cooperFarms2010: [this.au.cooperFarms2010, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      cooperFarms2011: [this.au.cooperFarms2011, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      cooperFarms2012: [this.au.cooperFarms2012, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      cooperFarms2013: [this.au.cooperFarms2013, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      cooperFarms2014: [this.au.cooperFarms2014, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      cooperFarms2015: [this.au.cooperFarms2015, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      cooperFarms2016: [this.au.cooperFarms2016, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],

      farbestFoods2010: [this.au.farbestFoods2010, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      farbestFoods2011: [this.au.farbestFoods2011, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      farbestFoods2012: [this.au.farbestFoods2012, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      farbestFoods2013: [this.au.farbestFoods2013, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      farbestFoods2014: [this.au.farbestFoods2014, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      farbestFoods2015: [this.au.farbestFoods2015, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      farbestFoods2016: [this.au.farbestFoods2016, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],

      fosterFarms2010: [this.au.fosterFarms2010, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      fosterFarms2011: [this.au.fosterFarms2011, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      fosterFarms2012: [this.au.fosterFarms2012, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      fosterFarms2013: [this.au.fosterFarms2013, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      fosterFarms2014: [this.au.fosterFarms2014, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      fosterFarms2015: [this.au.fosterFarms2015, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      fosterFarms2016: [this.au.fosterFarms2016, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],

      hormel2010: [this.au.hormel2010, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      hormel2011: [this.au.hormel2011, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      hormel2012: [this.au.hormel2012, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      hormel2013: [this.au.hormel2013, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      hormel2014: [this.au.hormel2014, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      hormel2015: [this.au.hormel2015, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      hormel2016: [this.au.hormel2016, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],

      perdue2010: [this.au.perdue2010, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      perdue2011: [this.au.perdue2011, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      perdue2012: [this.au.perdue2012, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      perdue2013: [this.au.perdue2013, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      perdue2014: [this.au.perdue2014, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      perdue2015: [this.au.perdue2015, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      perdue2016: [this.au.perdue2016, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],

      prestage2010: [this.au.prestage2010, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      prestage2011: [this.au.prestage2011, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      prestage2012: [this.au.prestage2012, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      prestage2013: [this.au.prestage2013, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      prestage2014: [this.au.prestage2014, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      prestage2015: [this.au.prestage2015, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      prestage2016: [this.au.prestage2016, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],

      tyson2010: [this.au.tyson2010, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      tyson2011: [this.au.tyson2011, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      tyson2012: [this.au.tyson2012, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      tyson2013: [this.au.tyson2013, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      tyson2014: [this.au.tyson2014, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      tyson2015: [this.au.tyson2015, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      tyson2016: [this.au.tyson2016, Validators.compose([Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],

      nameOne: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      attention: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      streetOne: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      streetTwo: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state: ['', Validators.compose([Validators.required])],
      country: ['', Validators.compose([Validators.required])],
      province: ['', Validators.compose([Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      postalCode: [''],
      zip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      phoneType: ['', Validators.compose([Validators.required])],
      phoneNumber: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      agreeOrDisagree: ['Disagree'],
      email: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("^[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      title: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      googleRecaptchaToken: ['', Validators.compose([Validators.required])],
      claimDetails: this.fb.array([])
    });

    this.normalizeLoadedPurchaseAmounts();

    // Capture the original purchase-matrix values so we can later detect which fields the claimant actually changed.
    for (const row of this.purchaseMatrix) {
      for (const controlName of row.controls) {
        this.purchaseMatrixBaseline[controlName] = this.claimantsInformation.get(controlName)?.value;
      }
    }
  }

  loadAllStates() {
    this.httpClient.get("assets/States.json").subscribe(data => {
      /* console.log(data);*/
      this.allStates = data;
    })
  }

  loadAllCountries() {
    this.httpClient.get("assets/Countries.json").subscribe(data => {
      console.log(data);
      this.allCountries = data;
      this.cdr.detectChanges();
    })
  }

  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  get f() { return this.claimantsInformation.controls; }

  getCountryValue($event) {
    this.changed = true;
    // if you need the event source and value it can be accessed.
    console.log($event.target.value);
    if ($event.target.value !== 'United States') {
      this.showDivProvince = true;
      this.showDivCityStateZip = false;

      this.claimantsInformation.get('state').clearValidators();
      this.claimantsInformation.get('state').updateValueAndValidity();
      this.claimantsInformation.get('state').reset();
      this.claimantsInformation.get('zip').clearValidators();
      this.claimantsInformation.get('zip').updateValueAndValidity();
      this.claimantsInformation.get('zip').reset();
      this.claimantsInformation.get('city').reset();
      this.claimantsInformation.get('postalCode').setValidators(Validators.compose([Validators.maxLength(10)]));
      this.claimantsInformation.get('province').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    }

    if ($event.target.value === 'United States') {
      /* */
      this.showDivProvince = false;
      this.showDivCityStateZip = true;

      this.claimantsInformation.get('city').reset();
      this.claimantsInformation.get('province').reset();
      this.claimantsInformation.get('postalCode').reset();

      this.claimantsInformation.get('province').clearValidators();
      this.claimantsInformation.get('province').updateValueAndValidity();
      this.claimantsInformation.get('postalCode').clearValidators();
      this.claimantsInformation.get('postalCode').updateValueAndValidity();

      this.claimantsInformation.get('city').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.claimantsInformation.get('state').setValidators(Validators.compose([Validators.required]));
      this.claimantsInformation.get('zip').setValidators(Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")]));
    }
  }

  getPhoneType2Value() {
    this.changed = true;
    const secondaryPhoneType = this.claimantsInformation.get('secondaryPhoneType')?.value;

    if (secondaryPhoneType !== '') {
      this.claimantsInformation.get('secondaryPhone').setValidators(Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")]));
    } else {
      this.claimantsInformation.get('secondaryPhone').clearValidators();
    }
    this.claimantsInformation.get('secondaryPhone').updateValueAndValidity();
  }

  // Enter inline-edit mode for a single purchase-table cell.
  startEdit(controlName: string) {
    this.editingCell = controlName;
  }

  // Exit inline-edit mode and recompute the displayed total.
  // If the cell currently has validation errors, stay in edit mode so the warning remains visible.
  stopEdit() {
    if (this.editingCell && this.cellControl(this.editingCell)?.errors) {
      this.recalculateTotal();
      return;
    }
    this.editingCell = null;
    this.recalculateTotal();
  }

  isEditing(controlName: string): boolean {
    return this.editingCell === controlName;
  }

  cellControl(controlName: string) {
    return this.claimantsInformation.get(controlName);
  }

  // Normalize prepopulated amounts so they comply with the four-decimal validation rule.
  normalizeLoadedPurchaseAmounts() {
    for (const row of this.purchaseMatrix) {
      for (const controlName of row.controls) {
        const control = this.claimantsInformation.get(controlName);
        const value = control?.value;
        const numericValue = typeof value === 'string' && value.trim() !== '' ? Number(value) : value;

        if (Number.isFinite(numericValue)) {
          control?.setValue(numericValue.toFixed(4).replace(/\.?0+$/, ''), { emitEvent: false });
        }
      }
    }

    this.recalculateTotal();
  }

  // Recalculate purchaseNetTotal from all editable purchase-matrix controls.
  recalculateTotal() {
    let total = 0;
    for (const row of this.purchaseMatrix) {
      for (const controlName of row.controls) {
        const value = parseFloat(this.claimantsInformation.get(controlName)?.value);
        if (!isNaN(value)) {
          total += value;
        }
      }
    }
    this.claimantsInformation.get('purchaseNetTotal')?.setValue(total.toFixed(4).replace(/\.?0+$/, ''));
  }

  //getRadioAgreeanceValue($event) {
  //  // if you need the event source and value it can be accessed.
  //  console.log($event.target.value);
  //  if ($event.target.value == 'Disagree') {
  //    this.showDivPurchaseUploadDocs = true;

  //  }
  //  if ($event.target.value == 'Agree') {
  //    this.showDivPurchaseUploadDocs = false;
  //    this.resetFormArray();
  //  }
  //}


  // Clear ClaimDetails Form Array Controls
  resetFormArray() {
    this.claimDetails().clear();
  }

  // Build the claimDetails FormArray from the purchaseMatrix controls so that
  // only purchase amounts that the claimant actually changed from their original value
  // become rows, each with defendant, purchaseYear, and purchaseAmount.
  buildClaimDetailsFromMatrix() {
    this.resetFormArray();
    const netTotal = this.claimantsInformation.get('purchaseNetTotal')?.value;
    for (const row of this.purchaseMatrix) {
      for (const controlName of row.controls) {
        const rawValue = this.claimantsInformation.get(controlName)?.value;
        const originalValue = this.purchaseMatrixBaseline[controlName];
        const hasValue = rawValue !== null && rawValue !== undefined && rawValue !== '';
        const wasChanged = hasValue && rawValue !== originalValue;
        if (wasChanged) {
          const yearMatch = controlName.match(/\d{4}$/);
          const purchaseYear = yearMatch ? yearMatch[0] : '';
          const claimDetailGroup = this.newClaimDetail();
          claimDetailGroup.patchValue({
            purchaseYear: purchaseYear,
            defendant: row.label,
            purchaseAmount: rawValue,
            purchaseNetTotal: netTotal
          });
          this.claimDetails().push(claimDetailGroup);
        }
      }
    }
  }

  // Remove the second element and so on
  removeAllExceptFirst(formArray: FormArray): void {
    while (formArray.length > 1) {
      formArray.removeAt(0);
    }
  }

  removeTable() {
    if (this.tableRef) {
      this.tableRef.nativeElement.remove();
    }
  }

  // Declare FormArray Function
  claimDetails(): FormArray {
    return this.claimantsInformation.get('claimDetails') as FormArray
  }

  // Create new Form Array
  newClaimDetail(): FormGroup {
    return this.fb.group({
      purchaseYear: ['', Validators.compose([Validators.required])],
      defendant: ['', Validators.compose([Validators.required])],
      purchaseAmount: ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.pattern("^\\d{0,15}(?:[.]\\d{1,4})?$")])],
      purchaseNetTotal: [''],
    });
  }

  // Create a New Array Function
  claimDetailARR(index) {
    this.cdList = this.claimantsInformation.get('claimDetails') as FormArray;
    const formGroup = this.cdList.controls[index] as FormGroup;
    return formGroup;
  }

  addData() {
    (<FormArray>this.claimantsInformation.get('claimDetails')).push(this.newClaimDetail());
    this.showDivDisagreePurchaseMessage = false;
  }

  removeData(i: number) {
    this.claimDetails().removeAt(i)
  }

  getFileDetails(e) {
    console.log(this.supportingDocuments);
    for (var i = 0; i < e.target.files.length; i++) {
      this.supportingDocuments.push(e.target.files[i]);
      //console.log(e.target.files[i]);
      //if (this.supportingDocuments.length >= 1) {
      //  this.showDivUploadDocumentMessage = false;
      //}
    }
  }

  removeRow(i: number) {
    this.supportingDocuments.splice(i, 1);
    this.fileInput.nativeElement.value = null;
  }

  onSubmit() {
    this.submitted = true;
    this.dateLoaded = new Date();
    this.claimEndTime = this.dateLoaded.toLocaleTimeString();

    // Ensure any in-progress cell edit is committed before validating/submitting.
    this.stopEdit();

    // Populate claimDetails from the purchase matrix so each entered amount is saved as its own ClaimDetails row.
    this.buildClaimDetailsFromMatrix();

    // At least one purchase-matrix field must be updated from its original value before submitting.
    if (this.claimDetails().length === 0) {
      this.showDivDisagreePurchaseMessage = true;
      return;
    }
    this.showDivDisagreePurchaseMessage = false;

    // stop here if form is invalid
    if (this.claimantsInformation.invalid) {
      return;
    }

    this.clicked = true;
    const claimant = this.claimantsInformation.value;
    claimant.claimStartTime = this.claimStartTime;
    claimant.claimEndTime = this.claimEndTime;

    this.spinner.show();

    /*console.log(claimant);*/
    this.CreateClaimant(claimant);
  }

  CreateClaimant(claimant: Claimant) {
    const message = "Unable to save claimant data.";

    this.claimantService.createClaimant(claimant).subscribe(res => {
      this.submittedClaim = res;
      if (this.submittedClaim.statusMessage === message) {
        this.showSubmittalErrorWarning = true;
        return;
      }
      this.SubmitDocuments(this.submittedClaim.claimNumber);
    });
  }

  SubmitDocuments(claimNumber: string) {
    this.claimantService.submitDocuments(this.submittedClaim.claimNumber, this.supportingDocuments).subscribe(() => {
    });
    this.storage.store('claimant', this.submittedClaim);
    // this.submitted = false;
    this.claimantsInformation.reset();
    this.spinner.hide();
    this.router.navigate(['/complete']);
  }
}
